import { formatNumber } from "@/lib/format";

import type { ModuleStatus, ProjectSummary } from "../types";

/**
 * What Studio tells the project about itself (FR-PROJ-056, FR-STUDIO-008): the stage the project is at, which the
 * sidebar, cards and board show, and Studio's status in the module list, "Set up" until the project's Studio has
 * stages and then its open tasks ("5 open"). The identity service answers both with the project; the mock's Studio
 * reports them after each change (`recordStudio`).
 */
export interface StudioSummary {
  /** The current stage's position: the first one not signed off or skipped, else the last signed off. */
  readonly stageIndex: number;
  /** Tasks not done. */
  readonly openTasks: number;
}

/** Studio's status in the module list: `null` when the project's Studio has no stages yet. */
export function studioStatus(openTasks: number | null | undefined): ModuleStatus {
  return openTasks === null || openTasks === undefined
    ? { module: "studio", label: "Set up", tone: "neutral" }
    : { module: "studio", label: `${formatNumber(openTasks)} open`, tone: "neutral" };
}

/** The project with Studio's stage and status in place of what it was made with. */
export function withStudio<T extends ProjectSummary>(project: T, summary: StudioSummary): T {
  return {
    ...project,
    stageIndex: summary.stageIndex,
    modules: project.modules.map((status) =>
      status.module === "studio" ? studioStatus(summary.openTasks) : status,
    ),
  };
}
